import React, { useState, useEffect } from 'react';

const LOGO_URL = '/brand/twp-logo.png';

export default function SplashScreen({ installerName, onComplete }) {
  const [visible, setVisible] = useState(true);
  const [currentTime, setCurrentTime] = useState(new Date());

  const getGreeting = () => {
    const hour = new Date().getHours();
    if (hour >= 5 && hour < 12) {
      return `Good morning, ${installerName}! 🌅`;
    } else if (hour >= 12 && hour < 17) {
      return `Good afternoon, ${installerName}! ☀️`;
    } else if (hour >= 17 && hour < 21) {
      return `Good evening, ${installerName}! 🌆`;
    } else {
      return `Working late, ${installerName}? 🌙`;
    }
  };

  useEffect(() => {
    const timeInterval = setInterval(() => {
      setCurrentTime(new Date());
    }, 1000);

    const timer = setTimeout(() => {
      setVisible(false);
      setTimeout(onComplete, 300);
    }, 3000);

    return () => {
      clearInterval(timeInterval);
      clearTimeout(timer);
    };
  }, [onComplete]);

  if (!visible) return null;

  const dateString = currentTime.toLocaleDateString('en-US', {
    weekday: 'long',
    year: 'numeric',
    month: 'long',
    day: 'numeric'
  });

  const timeString = currentTime.toLocaleTimeString('en-US', {
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit'
  });

  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      background: 'linear-gradient(135deg, #8B4513 0%, #A0522D 100%)',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 9999,
      animation: 'fadeOut 0.3s ease-out 2.7s forwards',
      padding: '20px'
    }}>
      <style>{`
        @keyframes fadeOut {
          to { opacity: 0; }
        }
        @keyframes slideUp {
          from {
            opacity: 0;
            transform: translateY(20px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
        @keyframes float {
          0%, 100% {
            transform: translateY(0);
          }
          50% {
            transform: translateY(-10px);
          }
        }
        @keyframes pulse {
          0%, 100% {
            box-shadow: 0 20px 60px rgba(0, 0, 0, 0.3);
          }
          50% {
            box-shadow: 0 25px 70px rgba(0, 0, 0, 0.4);
          }
        }
      `}</style>

      <div style={{
        textAlign: 'center',
        animation: 'slideUp 0.6s ease-out',
        maxWidth: '400px',
        width: '100%'
      }}>
        <div style={{
          background: 'white',
          borderRadius: '24px',
          padding: '40px',
          marginBottom: '32px',
          boxShadow: '0 20px 60px rgba(0, 0, 0, 0.3)',
          animation: 'float 3s ease-in-out infinite, pulse 3s ease-in-out infinite',
          display: 'inline-block'
        }}>
          <img
            src={LOGO_URL}
            alt="The Window Place LLC"
            style={{
              maxWidth: '200px',
              width: '100%',
              height: 'auto',
              display: 'block'
            }}
          />
        </div>

        <h1 style={{
          fontSize: '24px',
          fontWeight: '700',
          color: 'white',
          margin: '0 0 16px 0',
          textShadow: '0 2px 8px rgba(0,0,0,0.3)'
        }}>
          {getGreeting()}
        </h1>

        <div style={{
          background: 'rgba(255, 255, 255, 0.15)',
          backdropFilter: 'blur(10px)',
          borderRadius: '16px',
          padding: '20px',
          marginBottom: '24px',
          border: '1px solid rgba(255, 255, 255, 0.2)'
        }}>
          <div style={{
            fontSize: '15px',
            fontWeight: '600',
            color: 'white',
            marginBottom: '8px',
            textShadow: '0 1px 4px rgba(0,0,0,0.2)'
          }}>
            📅 {dateString}
          </div>
          <div style={{
            fontSize: '32px',
            fontWeight: '700',
            color: 'white',
            fontFamily: 'monospace',
            textShadow: '0 2px 6px rgba(0,0,0,0.3)',
            letterSpacing: '2px'
          }}>
            {timeString}
          </div>
        </div>

        <p style={{
          fontSize: '16px',
          color: 'rgba(255,255,255,0.95)',
          margin: '0 0 32px 0',
          fontWeight: '500',
          textShadow: '0 1px 4px rgba(0,0,0,0.2)'
        }}>
          Have a great day on the job!
        </p>

        <div style={{
          fontSize: '12px',
          color: 'rgba(255, 255, 255, 0.8)',
          textShadow: '0 1px 3px rgba(0, 0, 0, 0.3)',
          fontWeight: '500'
        }}>
          © {new Date().getFullYear()} The Window Place LLC
        </div>
      </div>
    </div>
  );
}